/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_DescriptionInputs */

const en_visa_l1_description = /** @type {(inputs: Visa_L1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The L category allows qualifying companies to transfer certain employees from abroad to a related U.S. entity. It is often used in cross-border growth and expansion strategies when the corporate relationship and job duties meet the regulatory requirements.`)
};

const pt_visa_l1_description = /** @type {(inputs: Visa_L1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A categoria L permite que empresas qualificadas transfiram certos funcionários do exterior para uma entidade relacionada nos EUA. É frequentemente usada em estratégias de crescimento e expansão transfronteiriça quando o relacionamento corporativo e as funções atendem aos requisitos regulatórios.`)
};

const es_visa_l1_description = /** @type {(inputs: Visa_L1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La categoría L permite que empresas calificadas transfieran a ciertos empleados del extranjero a una entidad relacionada en EE. UU. Se utiliza frecuentemente en estrategias de crecimiento y expansión transfronteriza cuando la relación corporativa y las funciones cumplen con los requisitos regulatorios.`)
};

/**
* | output |
* | --- |
* | "The L category allows qualifying companies to transfer certain employees from abroad to a related U.S. entity. It is often used in cross-border growth and ex..." |
*
* @param {Visa_L1_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_description = /** @type {((inputs?: Visa_L1_DescriptionInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_DescriptionInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_description(inputs)
	if (locale === "es") return es_visa_l1_description(inputs)
	return en_visa_l1_description(inputs)
});